import React from 'react';

const AddIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.724"
    height="16.724"
    viewBox="0 0 16.724 16.724"
  >
    <path
      d="M543.937,354.437H537.29v-6.646h-3.431v6.646h-6.646v3.431h6.646v6.647h3.431v-6.647h6.647Z"
      transform="translate(-527.213 -347.791)"
    />
  </svg>
);

export default AddIcon;
